var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostAddFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.222 22a2.14 2.14 0 0 1-1.57-.653A2.14 2.14 0 0 1 2 19.777V4.223q0-.915.653-1.57A2.14 2.14 0 0 1 4.223 2h8.888q.473 0 .792.32.32.318.32.791 0 .472-.32.792t-.792.32H4.222v15.555h15.556v-8.89q0-.471.32-.79.319-.32.79-.32.474 0 .793.32.318.319.319.79v8.89a2.14 2.14 0 0 1-.653 1.57 2.14 2.14 0 0 1-1.57.652zm4.445-4.444q-.473 0-.792-.32a1.08 1.08 0 0 1-.32-.792q0-.471.32-.791t.792-.32h6.666q.472 0 .792.32t.32.791-.32.792-.792.32zm0-3.334q-.473 0-.792-.32a1.08 1.08 0 0 1-.32-.79q0-.474.32-.793T8.667 12h6.666q.472 0 .792.32.32.318.32.791t-.32.792q-.32.32-.792.32zm0-3.333q-.473 0-.792-.32a1.08 1.08 0 0 1-.32-.791q0-.473.32-.792t.792-.32h6.666q.472 0 .792.32t.32.792-.32.791-.792.32zm10-2.222q-.473 0-.792-.32a1.08 1.08 0 0 1-.32-.791V6.444h-1.11q-.473 0-.792-.319a1.08 1.08 0 0 1-.32-.792q0-.471.32-.791t.791-.32h1.112v-1.11q0-.474.319-.793.32-.32.792-.319.471 0 .791.32.32.318.32.791v1.111h1.11q.474 0 .793.32.318.32.319.791 0 .473-.32.792-.318.32-.791.32h-1.111v1.11q0 .473-.32.792-.319.32-.791.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostAddFill);
export default __webpack_public_path__ + "static/media/post_add_fill.94def790d28281b9e6baaa7a2905992c.svg";
export { ForwardRef as ReactComponent };